import React from 'react';
import '../../styles/forwarding.css'; // Import Forwarding specific CSS
import '../../styles/Fonts.css'; // Import Fonts specific CSS
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome

const benefitsData = [
  {
    number: '01',
    title: 'Global Network',
    description: 'Access to worldwide partners and expertise ensuring smooth international shipping operations.',
    icon: 'fa-globe'
  },
  {
    number: '02',
    title: 'Cost Optimization',
    description: 'Consolidated shipments and negotiated carrier rates deliver significant cost savings.',
    icon: 'fa-hand-holding-dollar'
  },
  {
    number: '03',
    title: 'Full Compliance',
    description: 'Complete handling of documentation and customs regulatory requirements.',
    icon: 'fa-file-contract'
  },
  {
    number: '04',
    title: 'Risk Protection',
    description: 'Comprehensive insurance and risk management solutions for secure shipments.',
    icon: 'fa-shield-alt'
  }
];

const ForwardingBenefits = () => {
  return (
    <>
      {/* Forwarding Benefits Section */}
      <section id="benefits" className="services-preview-section">
        <div className="container">
          <div className="section-header">
            <div className="section-badge">WHY CHOOSE US</div>
            <h2 className="section-title">Forwarding Benefits</h2>
            <p className="section-description">
              Discover the key advantages of partnering with RCS Logistics for your forwarding needs.
            </p>
          </div>

          <div className="services-cards-grid forwarding-benefits">
            {benefitsData.map((benefit, index) => (
              <div key={index} className="service-card">
                <div className="service-card-icon">
                  <i className={`fas ${benefit.icon}`}></i>
                </div>
                <h3 className="service-card-title">{benefit.title}</h3>
                <p className="service-card-description">
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default ForwardingBenefits;
